import React, { FunctionComponent } from 'react';
import { ForgePaginator } from '@tylertech/forge-react';
import { IPaginatorChangeEventData } from '@tylertech/forge';
import { I18n } from 'common/i18n';
import { fetchAssetsByParameters, getResultsTotalSize } from '../store/AssetSlice';
import { useSelector } from 'react-redux';
import { getPageNumber, getLimit, updatePageNumberInUrl, updatePageSizeInUrl } from '../store/UrlSlice';
import { useAppDispatch } from '../store/hooks';
import { DEFAULT_PAGE_SIZE_OPTIONS } from '../types';
import { getResultSetSizeAsText } from '../helpers';

const ResultsPaginator: FunctionComponent = () => {
  const scope = 'controls.browse.browse3';
  const total = useSelector(getResultsTotalSize);
  const totalAsText = getResultSetSizeAsText(total);
  let index = useSelector(getPageNumber);
  index = index ? index - 1 : 0;
  let limit = useSelector(getLimit);
  limit = limit ? limit : 0;
  const dispatch = useAppDispatch();

  const onChangePage = (e: { detail: IPaginatorChangeEventData }) => {
    if (e.detail.type === 'page-size') {
      dispatch(updatePageSizeInUrl(e.detail.pageSize));
    }
    dispatch(updatePageNumberInUrl(e.detail.pageIndex + 1));
    dispatch(fetchAssetsByParameters());
  };

  // ForgePaginator takes "total" as number only, but we need to display the total count as text
  // when there are more than 10,000 results. So we need to construct the "range-label" manually.
  const first = index * limit + 1;
  const last = Math.min((index + 1) * limit, total);
  const rangeLabel = `${first}-${last} of ${totalAsText}`;

  return (
    <ForgePaginator
      data-testid="asset-results-paginator"
      firstLast
      label={I18n.t('results_per_page', { scope })}
      pageIndex={index}
      pageSize={limit}
      pageSizeOptions={DEFAULT_PAGE_SIZE_OPTIONS}
      total={total}
      on-forge-paginator-change={onChangePage}
    >
      <span slot="range-label">{rangeLabel}</span>
    </ForgePaginator>
  );
};

export default ResultsPaginator;
